"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ApiManagerAdmin_1 = require("../ApiManagerAdmin");
var ApiConfig_1 = require("../config/ApiConfig");
var ApiNewsFeed = /** @class */ (function (_super) {
    __extends(ApiNewsFeed, _super);
    function ApiNewsFeed() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.GET_NEWSFEED_LIST = "/api/newsFeed/list";
        _this.GET_NEWSFEED = "/api/newsFeed/view";
        _this.GET_NEWSFEED_NEW_ID = "/api/newsfeed/getNewId";
        _this.UPDATE_NEWSFEED = "/api/newsFeed/update";
        _this.DELETE_NEWSFEED = "/api/newsFeed/delete";
        _this.UPDATE_NEWSFEED_IMAGE_SORT = "/api/image/newsFeed/sort";
        /**
         * NewsFeed new item id get
         * @param accesstoken
         * @param language
         * @returns
         */
        _this.getNewsFeedNewId = function (accesstoken, language) {
            var data = {
                language: language,
            };
            var config = ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                method: "post",
                url: _this.GET_NEWSFEED_NEW_ID,
                data: data,
            });
            return config;
        };
        /**
         * NewsFeed List
         * @param accesstoken
         * @param language
         * @param page
         * @param limit
         * @returns
         */
        _this.getNewsFeedList = function (accesstoken, language, page, limit) {
            var data = {
                language: language,
                page: page,
                limit: limit,
            };
            var config = ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                method: "post",
                url: _this.GET_NEWSFEED_LIST,
                data: data,
            });
            return config;
        };
        /**
         * NewsFeed Item
         * @param accesstoken
         * @param newsFeedId
         * @returns
         */
        _this.getNewsFeed = function (accesstoken, newsFeedId) {
            var config = ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                method: "post",
                url: "".concat(_this.GET_NEWSFEED, "/").concat(newsFeedId),
            });
            return config;
        };
        /**
         * NewsFeed Update
         * @param accesstoken
         * @param newsFeedId
         * @param req
         * @returns
         */
        _this.updateNewsFeed = function (accesstoken, newsFeedId, req) {
            var config = ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                method: "post",
                url: "".concat(_this.UPDATE_NEWSFEED, "/").concat(newsFeedId),
                data: req,
            });
            return config;
        };
        /**
         * newsFeed Image 정렬 업데이트
         * @param accesstoken
         * @param newsFeedId
         * @param imageIds
         * @returns
         */
        _this.updateNewsFeedImageSort = function (accesstoken, newsFeedId, imageIds) {
            var data = {
                newsFeedId: newsFeedId,
                imageIds: imageIds,
            };
            var config = ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                method: "post",
                url: _this.UPDATE_NEWSFEED_IMAGE_SORT,
                data: data,
            });
            return config;
        };
        /**
         * NewsFeed delete
         * @param accesstoken
         * @param newsFeedId
         * @returns
         */
        _this.deleteNewsFeed = function (accesstoken, newsFeedId) {
            var config = ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                method: "post",
                url: "".concat(_this.DELETE_NEWSFEED, "/").concat(newsFeedId),
            });
            return config;
        };
        return _this;
    }
    ApiNewsFeed.getInstance = function (initValue) {
        if (!ApiNewsFeed.classInstance) {
            this.classInstance = new ApiNewsFeed(initValue);
        }
        return this.classInstance;
    };
    return ApiNewsFeed;
}(ApiManagerAdmin_1.ApiManager));
exports.default = ApiNewsFeed;
